import { Button } from '@cmpsr/components';
import { show as IntercomShow } from '@intercom/messenger-js-sdk';

interface ContactTeamButtonProps {
  variant?: 'light' | 'dark';
}

export const ContactTeamButton = ({ variant = 'light' }: ContactTeamButtonProps) => {
  return (
    <Button
      onClick={() => IntercomShow()}
      style={{
        backgroundColor: variant === 'light' ? '#AFDFFF' : '#183344',
        color: variant === 'light' ? '#183344' : '#AFDFFF',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '1.4',
        borderRadius: '100px',
        padding: '20px',
        height: '40px',
        width: '100%',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      Contact Our Team
    </Button>
  );
};

export default ContactTeamButton;
